import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import CfopService from "./cfopService"
import FormList from 'base/FormList'

export default function CfopList() {

    const [service] = useState(() => new CfopService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_cfop',
        dsName: 'descricao_cfop',
        mainField: { name: 'descricao_cfop', label: 'Descrição' },
        advFields: [
            { name: 'codigo_cfop', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_cfop', label: 'Descrição', type: 'string', inputMode: 'text' },
            { name: 'direito_cred_cfop', label: 'Direito a crédito', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'calc_ipi_cfop', label: 'calc IPI', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'exige_anp_cfop', label: 'Exige ANP', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'st_trib_cfop', label: 'Substituição tributária', type: 'boolean', component: 'TriStateCheckbox', value: null },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_cfop" sortable header="Código"></Column>
            <Column field="descricao_cfop" sortable header="Descrição"></Column>
        </FormList >
    )
}
